/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import NoticeList from "../../components/boards/NoticeList";
import QuestionList from "../../components/boards/QuestionList";
import SuggestionList from "../../components/boards/SuggestionList";
import ReferenceRoomList from "../../components/boards/ReferenceRoomList";

import NoticeDetail from "../../components/boards/NoticeDetail";
import QuestionDetail from "../../components/boards/QuestionDetail";
import SuggestionDetail from "../../components/boards/SuggestionDetail";
import ReferenceRoomDetail from "../../components/boards/ReferenceRoomDetail";

import {LoginAfterCheckLogin} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";
import "../../../css/admin_board.css";

const Boards = ({setMenuType,setMenuItem}) => {
  LoginAfterCheckLogin(0);  //로그인 상태 점검

  useEffect(() => {
    setMenuType('BOARDS');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  return (
    <Routes>
      {/* 게시판관리 */}
      <Route path="NoticeList" element={<NoticeList setMenuItem={setMenuItem}/>} />
      <Route path="QuestionList" element={<QuestionList setMenuItem={setMenuItem}/>} />
      <Route path="SuggestionList" element={<SuggestionList setMenuItem={setMenuItem}/>} />
      <Route path="ReferenceRoomList" element={<ReferenceRoomList setMenuItem={setMenuItem} />} />
      <Route path="NoticeDetail/:board_idx" element={<NoticeDetail setMenuItem={setMenuItem}/>} />
      <Route path="QuestionDetail/:board_idx" element={<QuestionDetail setMenuItem={setMenuItem}/>} />
      <Route path="SuggestionDetail/:board_idx" element={<SuggestionDetail setMenuItem={setMenuItem}/>} />
      <Route path="ReferenceRoomDetail/:rr_idx" element={<ReferenceRoomDetail setMenuItem={setMenuItem}/>} />
    </Routes>
  );
}
export default Boards;